module.exports = __webpack_public_path__ + "img/top-tiger-11.b4a60851.png";